type StoragePathProps = {
  filePath?: string
  zoneId?: string
  folderId?: string
  sceneId?: string
}

export const getStoragePath = () => {
  return process.env.REACT_APP_STORAGE
}

export const getFilePath = ({
  zoneId,
  filePath,
  folderId,
  sceneId,
}: StoragePathProps): string => {
  const storagePath = getStoragePath()
  if (!storagePath || !zoneId) return ''

  const normalizePath = (path: string) =>
    path.replace(/^\/+/, '').replace(/\/+$/, '')

  if (filePath) {
    return `${storagePath}zones/${zoneId}/${normalizePath(filePath)}/`
  }

  if (folderId) {
    return `${storagePath}zones/${zoneId}/${folderId}/`
  }

  if (sceneId) {
    return `${storagePath}zones/${zoneId}/scenes/${sceneId}/`
  }

  return ''
}
